import Schema, { optional, array, required } from 'AppReact/schema';

const label = { values: array(['string', 'object']), keys: array('string'), component: optional('function') };

const option = {
  id: required(['integer', 'string']),
  display: required('string'),
  subtitle: optional('string')
};

const ref = {
  current: optional('string'),
};

export default {
  options: Schema(option, 'array', { defaultValue: [] }),
  showAll: Schema('boolean', 'primitive', { defaultValue: false }),
  selectedOptionIds: Schema(['integer', 'string'], 'array', { defaultValue: [] }),
  label: Schema(label, 'object', { defaultValue: { values: [], keys: [], component: null } }),
  isOpen: Schema('boolean', 'primitive', { defaultValue: false }),
  multipleSelect: Schema('boolean', 'primitive', { defaultValue: false }),
  placeholder: Schema('string', 'primitive-nullable', { defaultValue: null }),
  bodyWidth: Schema('integer', 'primitive-nullable', { defaultValue: null }),
  searchTerm: Schema('string', 'primitive', { defaultValue: '' }),
  openOnTop: Schema('boolean', 'primitive-nullable', { defaultValue: null }),
  hasSearch: Schema('boolean', 'primitive', { defaultValue: false }),
  disabled: Schema('boolean', 'primitive', { defaultValue: false }),
  inputRef: Schema(ref, 'object', { defaultValue: null }),
  containerRef: Schema(ref, 'object', { defaultValue: null }),
  left: Schema('integer', 'primitive-nullable', { defaultValue: null }),
  borderColor: Schema('string', 'primitive-nullable', { defaultValue: null }),
  padding: Schema('string', 'primitive-nullable', { defaultValue: null }),
}
